/* eslint-disable indent */
/* eslint-disable no-undef */
export default {
	name: "addtional-products-and-service-pricing",
	data() {
		return {
			depotProducts: [],
			depotProductHeadings: [
				{
					text: "#",
					field: "productId"
				},
				{
					text: "Depot",
					field: "depot"
				},
				{
					text: "Name",
					field: "product"
				},
				{
					text: "Product Type",
					field: "productType"
				},
				{
					text: "Price",
					field: "priceAsString"
				},
				{
					text: "Is Active",
					field: "isActive"
				},
				{
					text: "Date Created",
					field: "insertedOn"
				}
			],
			pagingDetails:{
				pageNumber: 1,
				pageSize: 10,
				totalPages: 1
			},
			depots: [],
			productTypes: [
				{ id: 0, text: "All", value: 0 },
				{ id: 3, text: "Truck Wash", value: 3 },
				{ id: 4, text: "Oil", value: 4 },
				{ id: 5, text: "Overnight Stay", value: 5 }
			],
			actionKeys:{
				updatePricing: "updatePricing",
				markAsActiveInactive: "markAsActiveInactive",
			},
			updatePricingFormModal:{
				showModal: false,
				isSaving: false,
				modalId: "updatePricingModal",
				heading: "Update Pricing",
				depotProduct: {
					productId: null,
					depotProductId: null,
					activeFromDate: new Date(),
					price: null,
					depotId: null,
					isActive: null,
					effectiveDateErrorMessage: null,
					depotErrorMessage: null,
					priceErrorMessage: null
				}
			},
			depotPricingMarkAsActiveInactiveModal:{
				showModal: false,
				isSaving: false,
				modalId: "markAsActiveInactiveModal",
				heading: "Mark Depot Price As Active/Inactive",
				isActive: null
			},
			depotManageProductsModal:{
				showModal: false,
				isSaving: false,
				modalId: "manageDepotProductsModal",
				heading: "Manage Additional Services",
				depotId: null
			},
			filterStateChanged: false,
			filter:{
				customerSearchQuery: null,
				depotId: null,
				productTypeId: null,
				activeOrInactiveItems: 1
			},
			activeIsActiveKey:{
				active: 1,
				inactive: 0
			},
			pageNumber: 1,
			pageSize: 100,
			loading: false,
			selectedHeartbeatStatusCodeId: null
		};
	},
	methods: {
		getDepots(){
			this.loading = true;
			let request = {
				isActive: true,
				provinceId: 0
			};
			systemService.getAllDepots(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.depots = successResponse.data.result;
						this.depots = $.map(this.depots,
							function (obj) {
								obj.id = obj.id || obj.depotId;
								obj.text = obj.text || obj.name;
								return obj;
							});
						this.depots.unshift({
							depotId: 0,
							id: 0,
							text: "All"
						});
					}
					this.filter.depotId = this.depots.length > 0 ? this.depots[0].id : null;
					this.filter.productTypeId = 0;
					this.loading = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		getDepotAdditionalServicesAndProducts(){
			this.loading = true;
			let request = {
				depotId: this.filter.depotId === null ? 0 : this.filter.depotId,
				searchQuery: this.filter.customerSearchQuery,
				productTypeId: this.filter.productTypeId,
				pageNum: this.pagingDetails.pageNumber,
				pageSize: this.pagingDetails.pageSize,
				isActive: castingUtility.toBoolean(this.filter.activeOrInactiveItems),
			};
			orderService.getDepotAdditionalServicesAndProductsPrices(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.depotProducts = successResponse.data.result;
						this.pagingDetails.pageNumber = successResponse.data.pagingInfo.thisPage;
						this.pagingDetails.totalPages = successResponse.data.pagingInfo.totalPages;
						this.filterStateChanged = false;
						for(let i = 0; i < this.depotProducts.length; i++) {
							this.depotProducts[i].priceAsString = currencyHelper.numberToCurrency(this.depotProducts[i].price);
							this.depotProducts[i].actions = [
								{
									name: "Update Pricing",
									key: this.actionKeys.updatePricing
								},
								{
									name: this.depotProducts[i].isActive ? "Mark As Inactive" : "Mark As Active",
									key: this.actionKeys.markAsActiveInactive
								}
							];
						}
						this.depotProducts = dataTableHelper.castFieldValues(this.depotProducts);
					}
					this.loading = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		onDepotFilterSelect(depot){
			if(this.filter.depotId !== depot.id){
				this.filterStateChanged = true;
			}
			this.filter.depotId = depot.id;
		},
		onProductTypeFilterSelect(productType){
			console.log("productType", productType);
			if(this.filter.productTypeId !== productType.id){
				this.filterStateChanged = true;
			}
			this.filter.productTypeId = productType.id;
		},
		onPagingUpdated(pagingInfo){
			this.pagingDetails.pageNumber = pagingInfo.pageNumber;
			this.getDepotAdditionalServicesAndProducts();
		},
		onFilterSearchClicked(){
			console.log("Search filter clicked");
			this.getDepotAdditionalServicesAndProducts();
		},
		onActiveInactiveFilterSelected(activeOrInactiveKey){
			this.filter.activeOrInactiveItems = activeOrInactiveKey;
			this.filterStateChanged = true;
			console.log("filter", this.filter);
		},
		onManageProductsClick(){
			this.depotManageProductsModal.showModal = true;
			this.depotManageProductsModal.heading = "Manage Additional Services";
			this.depotManageProductsModal.depotId = this.filter.depotId;
		},
		onManageDepotProductsModalOkClicked(){
			this.depotManageProductsModal.showModal = false;
			this.getDepotAdditionalServicesAndProducts();
		},
		onProductActionClicked(actionAndData){
			console.log("actionAndData", actionAndData);
			if(actionAndData.action === this.actionKeys.updatePricing){
				this.updatePricingFormModal.showModal = true;
				this.updatePricingFormModal.depotProduct.depotProductId = actionAndData.data.depotProductPriceId;
				this.updatePricingFormModal.depotProduct.productId = actionAndData.data.productId;
				this.updatePricingFormModal.depotProduct.price = actionAndData.data.price;
				this.updatePricingFormModal.depotProduct.depot = actionAndData.data.depot;
				this.updatePricingFormModal.depotProduct.product = actionAndData.data.product;
				this.updatePricingFormModal.depotProduct.isActive = actionAndData.data.isActive;
				this.updatePricingFormModal.depotProduct.depotId = actionAndData.data.depotId;
			}
			else if(actionAndData.action === this.actionKeys.markAsActiveInactive){
				this.depotPricingMarkAsActiveInactiveModal.showModal = true;
				this.depotPricingMarkAsActiveInactiveModal.isActive = castingUtility.toBoolean(actionAndData.data.isActive);
				this.markAsActiveOrInactiveData = actionAndData;
			}
		},
		onNewPriceActiveFromSelected(date) {
			this.updatePricingFormModal.depotProduct.activeFromDate = date;
		},
		onUpdatePricingModalCloseClick(){
			this.updatePricingFormModal.showModal = false;
			this.clearDepotProductModel();
		},
		onUpdatePricingSaveClick(){
			this.updatePricingFormModal.isSaving = true;
			let request = {
				depotProductPriceId: this.updatePricingFormModal.depotProduct.depotProductId,
				depotId: this.updatePricingFormModal.depotProduct.depotId,
				productId: this.updatePricingFormModal.depotProduct.productId,
				price: this.updatePricingFormModal.depotProduct.price,
				transportFactor: 0,
				isActive: true,
				effectiveDate: this.updatePricingFormModal.depotProduct.activeFromDate
			};
			orderService.addOrUpdateDepotProductPrice(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.getDepotAdditionalServicesAndProducts();
						this.updatePricingFormModal.showModal = false;
						this.updatePricingFormModal.isSaving = false;
					} else{
						this.updatePricingFormModal.isSaving = false;
					}
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.updatePricingFormModal.isSaving = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		onMarkAsActiveInactiveSaveClick(isActive){
			this.depotPricingMarkAsActiveInactiveModal.isSaving = true;
			//this.depotPricingMarkAsActiveInactiveModal.isActive = isActive;
			let request = {
				depotProductPriceId: this.markAsActiveOrInactiveData.data.depotProductPriceId,
				isActive: isActive
			};
			orderService.markDepotProductPriceAsActiveOrInactive(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.getDepotAdditionalServicesAndProducts();
						this.depotPricingMarkAsActiveInactiveModal.showModal = false;
						this.depotPricingMarkAsActiveInactiveModal.isSaving = false;
					} else{
						this.depotPricingMarkAsActiveInactiveModal.isSaving = false;
					}
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.depotPricingMarkAsActiveInactiveModal.isSaving = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		setBreadcrumbs() {
			storeState.setPageTitleAction("Additional Services & Products Pricing");
			var breadcrumbs = [];
			var breadcrumbLogistics = {
				url: null,
				displayText: "Pricing"
			};
			var driverManagementBreadcrumb = {
				url: this.$route.path,
				displayText: "Additional Services & Products Pricing"
			};
			breadcrumbs.push(breadcrumbLogistics);
			breadcrumbs.push(driverManagementBreadcrumb);
			breadcrumbsStoreState.setBreadcrumbs(breadcrumbs);
		}
	},
	created() {
		this.setBreadcrumbs();
		this.getDepots();
		this.getDepotAdditionalServicesAndProducts();
	}
};